/* eslint-disable global-require */
import globModules from './glob-modules';

const reactModule = (Component, nodeList) => {
  const React = require('react');
  const { createRoot } = require('react-dom/client');

  nodeList.forEach(node =>
    createRoot(node).render(<Component {...node.dataset} />)
  );
};

const components = [
  {
    name: 'VideoFigure',
    loader: () => import('./components/VideoFigure')
  },
  {
    name: 'GenericCard',
    loader: () => import('./components/cards/GenericCard')
  },
  {
    name: 'ReadMore',
    loader: () => import('./components/ReadMore')
  },
  {
    name: 'StatsGraph',
    loader: () => import('./components/StatsGraph')
  },
  {
    name: 'ShareRow',
    loader: () => import('./components/ShareRow')
  },
  {
    name: 'FeaturedIndividual',
    loader: () => import('./components/FeaturedIndividual')
  },
  {
    name: 'TabPanel',
    loader: () => import('./components/TabPanel')
  },
  {
    name: 'ContentCard',
    loader: () => import('./components/cards/ContentCard')
  }
];

const modules = [
  {
    name: 'AccordionRow',
    loader: () => import('./modules/AccordionRow')
  },
  {
    name: 'ArticleMasthead',
    loader: () => import('./modules/ArticleMasthead')
  },
  {
    name: 'AcademicCalendar',
    loader: () => import('./modules/AcademicCalendar')
  },
  {
    name: 'AlertBanner',
    loader: () => import('./modules/AlertBanner')
  },
  {
    name: 'CrossLinkBlock',
    loader: () => import('./modules/bicentennial/CrossLinkBlock')
  },
  {
    name: 'StatisticsRow',
    loader: () => import('./modules/bicentennial/StatisticsRow')
  },
  {
    name: 'TestimonialCarousel',
    loader: () => import('./modules/TestimonialCarousel')
  },
  {
    name: 'SectionNavigation',
    loader: () => import('./modules/SectionNavigation')
  },
  {
    name: 'PublicationsResearchRow',
    loader: () => import('./modules/PublicationsResearchRow')
  },
  {
    name: 'RecognitionRow',
    loader: () => import('./modules/RecognitionRow')
  },
  {
    name: 'CardRowSwiper',
    loader: () => import('./modules/CardRowSwiper')
  },
  {
    name: 'StatsGraph',
    loader: () => import('./components/StatsGraph')
  },
  {
    name: 'FeaturedIndividualSwiper',
    loader: () => import('./modules/FeaturedIndividualSwiper')
  },
  {
    name: 'Login',
    loader: () => import('./modules/Login')
  },
  {
    name: 'ContentWithIconRow',
    loader: () => import('./modules/ContentWithIconRow')
  },
  {
    name: 'FullWidthCarousel',
    loader: () => import('./modules/FullWidthCarousel')
  },
  {
    name: 'LeadershipListing',
    loader: () => import('./modules/LeadershipListing')
  },
  {
    name: 'Pagination',
    loader: () => import('./components/Pagination')
  },
  {
    name: 'CalendarItem',
    loader: () =>
      import('./modules/react/AcademicCalendar/components/CalendarItem'),
    render: reactModule
  },
  {
    name: 'FacultyListingCard',
    loader: () => import('./modules/react/FacultyListing/FacultyListingCard')
  },
  {
    name: 'Modal',
    loader: () => import('./modules/Modal')
  },
  {
    name: 'ResultsListing',
    loader: () => import('./modules/react/ResultsListing'),
    render: reactModule
  },
  {
    name: 'CookieBanner',
    loader: () => import('./modules/CookieBanner')
  },
  {
    name: 'HeaderSearch',
    loader: () => import('./modules/react/HeaderSearch'),
    render: reactModule
  },
  {
    name: 'RfiForm',
    loader: () => import('./modules/react/RfiForm'),
    render: reactModule
  },
  {
    name: 'TfaForm',
    loader: () => import('./modules/TfaForm')
  },
  {
    name: 'LandingTopicPanels',
    loader: () => import('./modules/bicentennial/LandingTopicPanels')
  },
  {
    name: 'MediaGallery',
    loader: () => import('./modules/bicentennial/MediaGallery')
  },
  {
    name: 'SCurve',
    loader: () => import('./modules/bicentennial/SCurve')
  },
  {
    name: 'BicentennialTopNavigation',
    loader: () => import('./modules/bicentennial/top-navigation')
  },
  {
    name: 'Welcome',
    loader: () => import('./modules/bicentennial/Welcome')
  },
  {
    name: 'ClockAnimation',
    loader: () => import('./modules/bicentennial/ClockAnimation')
  },
  {
    name: 'BicentennialSectionNavigation',
    loader: () => import('./modules/bicentennial/SectionNavigation')
  },
  {
    name: 'BlogBanner',
    loader: () => import('./modules/BlogBanner')
  },
  {
    name: 'latest-articles-grid',
    loader: () => import('./modules/latest-articles-grid'),
    render: reactModule
  },
  {
    name: 'library-books',
    loader: () => import('./modules/LibraryBooks')
  },
  {
    name: 'AlumniHeader',
    loader: () => import('./modules/alumni/header/index')
  },
  {
    name: 'AlumniPrimaryNavigation',
    loader: () => import('./modules/alumni/header/AlumniPrimaryNavigation')
  }
];

export default [...globModules, ...components, ...modules];
